import {
  RejectedNoShadow as RejectedNoShadowIcon,
  PendingNoShadow as PendingNoShadowIcon,
} from 'common/components/svgs';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ArrowRightOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Input, Select, Tooltip, Popconfirm } from 'antd';
import CombinedSearchComponent from '~components/combined-search-component';
import { propertyDraftStatus } from '~constants/pending-approval';
import { vrUrlPrefix, vrLinkLabel } from '~constants/gallery';

const urlRegex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!%$&'()*+,;=.]+$/;

export default class SingleLink extends React.PureComponent {
  handleCheckButtonClick = value => {
    window.open(`${vrUrlPrefix}${value}`);
  };

  validatUrl = url => {
    if (urlRegex.test(`${vrUrlPrefix}${url}`)) {
      return true;
    }
    return false;
  };

  urlValidator = (rule, value, callback) => {
    if (value && !urlRegex.test(`${vrUrlPrefix}${value}`)) {
      callback('error');
    } else {
      callback();
    }
  };

  render() {
    const { t, virtualTourLinkItem, section, rooms, form, links } = this.props;
    const { getFieldValue, getFieldDecorator } = form;

    return (
      <div
        className="virtual-tour-link-item"
        ref={node => {
          this.selectContainer = node;
        }}
      >
        <div className="virtual-tour-link-item__column">
          <Popconfirm
            arrowPointAtCenter
            title={t('cms:cms.properties.edit.gallery.delete_virtual_tour_link_reminder')}
            placement="topLeft"
            onConfirm={() => {
              this.props.onDeleteLink(section, virtualTourLinkItem.id);
            }}
            okText={t('cms:cms.properties.edit.btn.yes')}
            cancelText={t('cms:cms.properties.edit.btn.no')}
          >
            <div className="virtual-tour-link-item__middle">
              <MinusCircleOutlined className="icon-delete" />
            </div>
          </Popconfirm>
        </div>
        <div className="virtual-tour-link-item__column">
          <Form.Item style={{ width: '100%' }}>
            <Tooltip
              arrowPointAtCenter
              getPopupContainer={() => this.selectContainer}
              overlayClassName={classNames('vr-tooltip', {
                'vr-tooltip--show': false,
              })}
              placement="top"
              title={t('cms:cms.properties.edit.gallery.virtual_tour.disable_modify_hint')}
            >
              {getFieldDecorator(`link-${virtualTourLinkItem.id}`, {
                validateTrigger: ['onBlur'],
                rules: [
                  {
                    validator: this.urlValidator,
                    message: this.props.t('cms:cms.properties.edit.others.invalid_hint'),
                  },
                  {
                    required: true,
                    message: this.props.t('cms:cms.listing.modal.error_message.can_not_empty'),
                  },
                  {
                    validator: (rule, value, callback) => {
                      if (
                        links.some(
                          link =>
                            link.id !== virtualTourLinkItem.id &&
                            link.link === `${vrUrlPrefix}${value}`,
                        )
                      ) {
                        callback('error');
                      }
                      callback();
                    },
                    message: this.props.t(
                      'cms:cms.properties.edit.gallery.duplicated_virtual_tour_link_error',
                    ),
                  },
                ],
                initialValue: virtualTourLinkItem.link
                  ? virtualTourLinkItem.link.replace(vrUrlPrefix, '')
                  : virtualTourLinkItem.link,
              })(
                <Input
                  disabled={!!virtualTourLinkItem.status}
                  className={classNames('virtual-tour-link-item__middle url', {
                    'url--valid': this.validatUrl(getFieldValue(`link-${virtualTourLinkItem.id}`)),
                  })}
                  autoComplete="off"
                  placeholder={t('cms:cms.properties.edit.gallery.virtual_tour.link_address_hint')}
                  addonBefore={
                    <span className="virtual-tour-link-item__url-prefix">{vrUrlPrefix}</span>
                  }
                  addonAfter={
                    <ArrowRightOutlined
                      onClick={() => {
                        this.handleCheckButtonClick(
                          getFieldValue(`link-${virtualTourLinkItem.id}`),
                        );
                      }}
                    />
                  }
                />,
              )}
            </Tooltip>
          </Form.Item>
        </div>
        <If condition={section === vrLinkLabel.PROPERTY}>
          <div className="virtual-tour-link-item__column">
            <Form.Item style={{ width: '100%' }}>
              <Tooltip
                arrowPointAtCenter
                getPopupContainer={() => this.selectContainer}
                overlayClassName={classNames('vr-tooltip', {
                  'vr-tooltip--show': false,
                })}
                placement="top"
                title={t('cms:cms.properties.edit.gallery.virtual_tour.disable_modify_hint')}
              >
                <div>
                  {getFieldDecorator(`area-${virtualTourLinkItem.id}`, {
                    initialValue: virtualTourLinkItem.area,
                    rules: [
                      {
                        required: true,
                        message: this.props.t('cms:cms.listing.modal.error_message.can_not_empty'),
                      },
                    ],
                  })(
                    <Select
                      style={{ width: '100%' }}
                      getPopupContainer={() => this.selectContainer}
                      disabled={!!virtualTourLinkItem.status}
                    >
                      <Select.Option value="GENERAL">
                        {t('cms:cms.properties.edit.gallery.library.title.general')}
                      </Select.Option>
                      <Select.Option value="BUILDING_EXTERIOR">
                        {t('cms:cms.properties.edit.gallery.library.title.building_exterior')}
                      </Select.Option>
                      <Select.Option value="COMMON_INDOOR_SPACES">
                        {t('cms:cms.properties.edit.gallery.library.title.common_indoor_spaces')}
                      </Select.Option>
                      <Select.Option value="COMMON_OUTDOOR_SPACES">
                        {t('cms:cms.properties.edit.gallery.library.title.common_outdoor_spaces')}
                      </Select.Option>
                    </Select>,
                  )}
                </div>
              </Tooltip>
            </Form.Item>
          </div>
        </If>
        <If condition={section === vrLinkLabel.ROOM}>
          <div className="virtual-tour-link-item__column">
            <div>
              <CombinedSearchComponent
                disabled={!!virtualTourLinkItem.status}
                rooms={rooms}
                form={form}
                virtualTourLink={virtualTourLinkItem}
                t={t}
                onChange={(currentLink, selectedRooms) => {
                  this.props.onSetSelectedRooms(currentLink, selectedRooms);
                }}
              />
            </div>
          </div>
        </If>
        <div className="virtual-tour-link-item__column">
          <Choose>
            <When condition={virtualTourLinkItem.status === propertyDraftStatus.REJECTED}>
              <span className="virtual-tour-link-item__status-wrap virtual-tour-link-item__status-wrap--rejected">
                <RejectedNoShadowIcon className="virtual-tour-link-item__rejected-tag" />
              </span>
            </When>
            <When condition={virtualTourLinkItem.status === propertyDraftStatus.PENDING}>
              <span className="virtual-tour-link-item__status-wrap virtual-tour-link-item__status-wrap--pending">
                <PendingNoShadowIcon className="virtual-tour-link-item__pending-tag" />
              </span>
            </When>
          </Choose>
        </div>
      </div>
    );
  }
}

SingleLink.propTypes = {
  t: PropTypes.func,
  virtualTourLinkItem: PropTypes.object,
  links: PropTypes.array,
  form: PropTypes.object,
  section: PropTypes.string,
  rooms: PropTypes.array,
  onDeleteLink: PropTypes.func,
  onSetSelectedRooms: PropTypes.func,
};

SingleLink.defaultProps = {
  t: () => {},
  virtualTourLinkItem: {},
  links: [],
  form: {},
  section: vrLinkLabel.PROPERTY,
  rooms: [],
  onDeleteLink: () => {},
  onSetSelectedRooms: () => {},
};
